import gsap from 'gsap'
import $ from 'jquery'

import Swiper from "swiper"
import { Navigation, Autoplay, FreeMode, EffectFade, Pagination } from "swiper/modules"
import SplitText from 'gsap/SplitText';

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import "swiper/css/effect-fade"

export const swiper = () => {
	homeBanner()
	navigationBlocks()
	videoCarousel()
	statistics()
	testimonials()
}

const syncKhPillarPreview = slug => {
	const root = document.querySelector('[data-el="kh-pillars"]')
	if (!root) return
	root.querySelectorAll('[data-pillar-group]').forEach(g => {
		if (g.getAttribute('data-pillar-group') === slug) g.setAttribute('data-active', 'true')
		else g.removeAttribute('data-active')
	})
	root.querySelectorAll('[data-pillar-cta]').forEach(c => {
		if (c.getAttribute('data-pillar-cta') === slug) c.setAttribute('data-active', 'true')
		else c.removeAttribute('data-active')
	})
	requestAnimationFrame(() => {
		if ($.fn.matchHeight && typeof $.fn.matchHeight._update === 'function') {
			$.fn.matchHeight._update()
		}
	})
}

const homeBanner = () => {

	let el = document.querySelector('[data-swiper="home-banner"]')

	if (!el) return false

	const carousel = new Swiper(el, {
		modules: [Pagination, EffectFade],
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 1000,
		pagination: {
			el: el.querySelector('.swiper-pagination'),
			clickable: true,
			renderBullet: (index, className) => {
				const slides = el.querySelectorAll('.swiper-slide')
				const label = slides[index]?.getAttribute('data-label')
				return `<span class="${className}" data-cursor="pointer"><i>${label}</i></span>`
			},
		},


		on: {
			slideChangeTransitionStart() {

				const activeSlide = carousel.slides[carousel.activeIndex];
				const heading = activeSlide.querySelector('.slide-heading');

				if (heading && window.innerWidth > 960) {
					gsap.killTweensOf(heading);
					heading.innerHTML = heading.textContent;

					const split = new SplitText(heading, {
						type: 'lines,words',
						linesClass: 'line',
						wordsClass: 'word',
					});

					gsap.fromTo(
						split.words,
						{
							y: '115%',
							opacity: 0,
							rotate: '4deg',
						},
						{
							y: 0,
							opacity: 1,
							rotate: '0deg',
							stagger: { each: 0.05, amount: 0.5 },
							duration: 1.2,
							ease: 'power2.out',
							delay: 0.1,
						}
					);
				}

				let background = activeSlide.getAttribute('data-background'),
					color = activeSlide.getAttribute('data-text')

				if (background) {
					el.parentElement.parentElement.style.backgroundColor = background
					el.parentElement.parentElement.dataset.text = color
				}

				const pillar = activeSlide.getAttribute('data-pillar')
				if (pillar) syncKhPillarPreview(pillar)
			},
		},
	})
}

const navigationBlocks = () => {

	let els = document.querySelectorAll('[data-swiper="navigation-blocks"]')

	if (!els.length) return false

	els.forEach(el => {
		const count = el.querySelectorAll('.swiper-slide').length
		const cap = v => Math.min(v, count)

		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: cap(1.15),
			spaceBetween: 12,
			grabCursor: true,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				782: {
					slidesPerView: cap(2.5),
					spaceBetween: 24,
				},
				1400: {
					slidesPerView: cap(4),
				},
			}
		})

		const $headings = $(el).find('[data-mh="card-heading"]')
		$headings.matchHeight('remove')
		$headings.matchHeight()

		const $details = $(el).find('[data-mh="card-detail"]')
		$details.matchHeight('remove')
		$details.matchHeight()
	})
}

const videoCarousel = () => {

	let els = document.querySelectorAll('[data-swiper="video-carousel"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation, EffectFade, Autoplay],
			loop: true,
			autoplay: {
				delay: 7000,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 1000,
			navigation: {
				prevEl: el.querySelector('[data-navigation="previous"]'),
				nextEl: el.querySelector('[data-navigation="next"]'),
			},
			on: {
				slideChangeTransitionStart: () => {
					let bar = el.querySelector('[data-el="progress-bar"]')
					gsap.fromTo(bar,
						{ width: '0%' },
						{
							width: '100%',
							duration: 8,
							ease: 'linear'
						}
					);
				}
			}
		})
	})
}

const statistics = () => {

	let els = document.querySelectorAll('[data-swiper="statistics"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1.15,
			spaceBetween: 12,
			grabCursor: true,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				782: {
					slidesPerView: 2.5,
					spaceBetween: 24,
				},
				960: {
					slidesPerView: 3,
				},
			}
		})
	})
}

const testimonials = () => {

	let els = document.querySelectorAll('[data-swiper="testimonials"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1.15,
			spaceBetween: 12,
			grabCursor: true,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			breakpoints: {
				600: {
					slidesPerView: 1.8,
				},
				782: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				960: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},
			}
		})
	})
}

export default () => { }